import { render, staticRenderFns } from "./ParentStudentRow.vue?vue&type=template&id=5c6be28e&scoped=true"
import script from "./ParentStudentRow.vue?vue&type=script&lang=js"
export * from "./ParentStudentRow.vue?vue&type=script&lang=js"
import style0 from "./ParentStudentRow.vue?vue&type=style&index=0&id=5c6be28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6be28e",
  null
  
)

export default component.exports